import { useState } from "react";
import printmedia1 from "../assets/printmedia1.png"
import printmedia2 from "../assets/printmedia2.png"
import printmedia3 from "../assets/printmedia3.png"
import printmedia4 from "../assets/printmedia4.png"
import news1 from "../assets/News1.jpeg"
import news2 from "../assets/News2.jpeg"
import news3 from "../assets/News3.jpeg"
import news4 from "../assets/News4.jpeg"
import news5 from "../assets/News5.jpeg"
import news6 from "../assets/News6.jpeg"
import news7 from "../assets/News7.jpeg"
import news8 from "../assets/News8.jpeg"

const Media = () => {
  const [activetab, setactivetab] = useState("All");

  const tabs = [
    { name: "All", id: "all" },
    { name: "Videos", id: "Media" },
    { name: "Press & Media", id: "Articles" },
  ];

  const handleTabClick = (tab, sectionId) => {
    setactivetab(tab);
    document.getElementById(sectionId).scrollIntoView({
      behavior: "smooth",
    });
  };

  const youtubedata = [
    {
      urllink: "https://www.youtube.com/embed/oHhnJklLBCQ",
      body: "Safe women one pad awareness program"
    },
    {
      urllink: "https://youtu.be/yyZmNdKjKMA?si=iHIWX_5yJezZzyVD",
      body: "नोएडा : भविष्य करता है लोगों के वर्तमान की चिंता। Bhavishya NGO"
    },
    {
      urllink: "https://youtube.com/shorts/0gnZRQ5N1X0?si=NMLdrTWCSwFWk26i",
      body: "महिला सशक्तिकरण ग्रीष्मकालीन शिविर | women empowerment"
    },
    {
      urllink: "https://youtube.com/shorts/BrDZ-l7nQ78?si=9hxHH7efD0G-tckj",
      body: "Mission Pratibhag to spread awareness about sugar harmful effects"
    },
    {
      urllink: "https://youtube.com/shorts/oX328RnPBfg?si=JDCTxZgtzeb2-4-N",
      body: "भविष्य एनजीओ ने खेलकूद के उत्साह से मनाया नव वर्ष"
    },
    {
      urllink: "https://youtube.com/shorts/vFPffU817xg?si=kLbpjq-2hhIYZAz",
      body: "भविष्य एनजीओ की पांचवी शाखा का उद्घाटन आज कोठिया बिहार में हुआ"
    },
  ];

  const getEmbedUrl = (url) => {
    let videoId = "";

    if (url.includes("youtube.com/embed/")) {
      videoId = url.split("youtube.com/embed/")[1].split("?")[0];
    }
    else if (url.includes("youtu.be/")) {
      videoId = url.split("youtu.be/")[1].split("?")[0];
    }
    else if (url.includes("youtube.com/shorts/")) {
      videoId = url.split("youtube.com/shorts/")[1].split("?")[0];
    }
    else if (url.includes("watch?v=")) {
      videoId = url.split("watch?v=")[1].split("&")[0];
    }

    return `https://www.youtube.com/embed/${videoId}`;
  };

  const pressMediaImages = [
    { img: printmedia1, type: "print" },
    { img: printmedia2, type: "print" },
    { img: printmedia3, type: "print" },
    { img: printmedia4, type: "print" },
    { img: news1, type: "news" },
    { img: news2, type: "news" },
    { img: news3, type: "news" },
    { img: news4, type: "news" },
    { img: news5, type: "news" },
    { img: news6, type: "news" },
    { img: news7, type: "news" },
    { img: news8, type: "news" },
  ];

  return (
    <div className="w-full min-h-screen bg-[#FAFAFA]">
      {/* Header Section */}
      <div className='w-full px-4 sm:px-[50px] py-[40px] sm:py-[60px] flex flex-col items-center justify-center gap-[12px] bg-[#EE645A] font-poppins text-center text-white'>
        <h1 className='font-bold text-[28px] sm:text-[40px]'>
          Media & Press
        </h1>

        <p className='max-w-[900px] h-auto font-normal text-[14px] sm:text-[18px] text-[#FFFFFFCC] mt-3'>
          Our journey and stories featured across digital, print, and news platforms
        </p>
      </div>

      {/* Tabs Section */}
      <div className="w-full bg-white border-b border-[#EEE] sticky top-0 z-10">
        <div className="max-w-[1320px] mx-auto px-4 py-4">
          <div className='flex flex-wrap justify-center gap-4 font-poppins'>
            {tabs.map((tabItem) => (
              <button
                key={tabItem.name}
                onClick={() => handleTabClick(tabItem.name, tabItem.id)}
                className={`px-6  rounded-full font-medium text-[15px] transition-all duration-300 ${
                  activetab === tabItem.name
                    ? 'bg-[#EE645A] text-white shadow-md'
                    : 'bg-[#FFF8F6] text-[#000000] hover:bg-[#FFECE8] border border-[#EE645A]'
                }`}
              >
                {tabItem.name}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Main Container */}
      <div className="max-w-[1320px] mx-auto px-4 py-12">

        {/* YouTube/Videos Section */}
        <div id="Media" className="w-full mb-16">
          <div className='flex flex-col items-center justify-center text-center mb-10'>
            <h2 className='font-bold text-[28px] sm:text-[36px] text-[#000000] mb-3'>
              Our Videos
            </h2>
            <p className='max-w-[700px] font-normal text-[15px] sm:text-[16px] text-[#666666]'>
              Watch our latest documentaries, interviews, and awareness campaigns featuring our initiatives and impact stories
            </p>
          </div>

          <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 justify-items-center'>
            {youtubedata.map((item, idx) => (
              <div
                key={idx}
                className='w-full max-w-[428px] bg-white rounded-[16px] shadow-md hover:shadow-lg transition-all duration-300 overflow-hidden group'
              >
                <div className='relative w-full h-[240px] bg-gray-200 overflow-hidden'>
                  <iframe
                    src={getEmbedUrl(item.urllink)}
                    className='w-full h-full'
                    title={`youtube-video-${idx}`}
                    allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
                    allowFullScreen
                  ></iframe>
                </div>
                <div className='p-5'>
                  <p className='font-normal text-[14px] sm:text-[15px] text-[#333333] leading-relaxed line-clamp-3 group-hover:text-[#EE645A] transition-colors'>
                    {item.body}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Press & Media Section (Merged News + Print Media) */}
        <div id="Articles" className="w-full">
          <div className='flex flex-col items-center justify-center text-center mb-10'>
            <h2 className='font-bold text-[28px] sm:text-[36px] text-[#000000] mb-3'>
              Press & Media Coverage
            </h2>
            <p className='max-w-[700px] font-normal text-[15px] sm:text-[16px] text-[#666666]'>
              Featured stories and articles from national press, print media, and news publications highlighting our work and impact
            </p>
          </div>

          <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 justify-items-center'>
            {pressMediaImages.map((item, idx) => (
              <div
                key={idx}
                className='w-full max-w-[428px] bg-white rounded-[16px] shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden group'
              >
                <div className='relative w-full h-[320px] overflow-hidden bg-gray-200'>
                  <img
                    src={item.img}
                    alt={`media-${idx}`}
                    className='w-full h-full object-cover group-hover:scale-110 transition-transform duration-300'
                  />
                  <div className='absolute top-3 right-3 bg-[#EE645A] text-white px-3 py-1 rounded-full text-[12px] font-bold'>
                    {item.type === 'print' ? 'Print' : 'News'}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* CTA Section */}
        {/* <div className='mt-16 bg-[#EE645A] rounded-[16px] p-8 sm:p-12 text-white text-center'>
          <h3 className='font-bold text-[24px] sm:text-[32px] mb-4'>
            Stay Updated
          </h3>
          <p className='text-[16px] text-[#FFFFFFCC] mb-6 max-w-[600px] mx-auto'>
            Follow our social media channels and subscribe to our newsletter to get the latest news, videos, and press coverage
          </p>
          <div className='flex flex-wrap justify-center gap-4'>
            <button className='px-8 py-3 bg-white text-[#EE645A] font-bold rounded-[8px] hover:bg-gray-100 transition-colors'>
              Subscribe
            </button>
            <button className='px-8 py-3 border-2 border-white text-white font-bold rounded-[8px] hover:bg-white hover:text-[#EE645A] transition-colors'>
              Follow Us
            </button>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default Media;